import styled from "styled-components";
import { FlexContainer } from "BaseComponents/Flex";
import { SIDEMENU, MAINMENU } from "Framework/consts/menuTypes";
import React from "react";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";

export const Logo = ({ Src, width, margin, align }) => {
  return (
    <LogoLink width={width} margin={margin} align={align} href="/">
      <LogoImage src={Src} />
    </LogoLink>
  );
};
const LogoLink = styled.a`
  width: 220px;
  margin: ${({ margin }) => (margin ? margin : "0 0 15px 0")};
  width: ${({ width }) => width};
  align-self: ${({ align }) => (align ? align : "")};
`;
const LogoImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;
export const Arrow = styled.span`
  width: 0;
  height: 0;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;

  border-bottom: ${({ theme }) => `10px solid ${theme.colors.white}`};
  position: absolute;
  left: 86%;
  opacity: ${({ show }) => (show ? "1" : "0")};
  transform: ${({ show }) => (show ? "translateX(0px)" : " translateX(20px)")};

  ${media.lessThan(breakpoints.ipadPro)`display: none;`}

  margin-top: -9px;
  transition: ${({ show }) =>
    show ? "opacity 0.5s ease, transform 0.5s ease" : ""};
`;
export const MainMenuTop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 0 21px;
`;
export const MainMenuContent = styled.div`
  display: flex;
  height: 100%;
  /* align-items: center; */
  flex-direction: column;
`;
export const ButtonWrapper = styled.div`
  width: 100%;
  padding: 20px 10px;
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.lessThan(breakpoints.ipad)`
	justify-content: flex-start;
	background-color: white;
	
	`}
`;
export const Icon = styled.i`
  color: white;
  font-size: 16px;
`;
export const MainMenuBottom = styled.div`
  display: flex;
  height: 100%;
  align-items: flex-end;
  margin-bottom: 20px;
  justify-content: center;
  ${media.lessThan(breakpoints.ipad)`
	margin-bottom: 0;
	
	justify-content: flex-start;
	`}
`;

export const MenuButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  transition: 0.2s ease;
  &:hover {
    background-color: transparent;
  }
  i::before {
    font-size: ${({ IconSize }) => IconSize};
  }
`;

export const ItemLink = styled.a`
  width: 100%;
  z-index: 1;
  display: flex;
  transition: 0.2s ease;    

  &:hover + ${MenuButtonWrapper} {
    transition: 0.2s ease;
    background-color: ${({ theme }) => theme.colors.bg1};
  }
  &:hover {
    transition: 0.2s ease;

    background-color: ${({ theme }) => theme.colors.bg1};
  }
  align-items: stretch;
  padding-left: ${({ Depth }) => (Depth > 1 ? 10 + Depth * 10 + "px" : "10px")};
`;
export const MenuItemText = styled.span.attrs(({ IsExpanded, lang }) => ({
  "aria-expanded": IsExpanded ? "true" : "false",
  lang: lang ? lang : "",
}))`
  & {
    color: ${({ IsActive }) =>
      IsActive ? "#1e1e1e" : "rgba(30, 30, 30, 0.85)"};
    font-weight: ${({ IsActive }) => (IsActive ? "bold" : "normal")};

    /* font-weight: ${({ IsExpanded }) => (IsExpanded ? "bold" : "")}; */
    display: flex;
    align-items: center;
    font-size: ${({ Depth }) => 17 - Depth + "px"};
    font-weight: bold;
    max-width: 184px;
  }
`;
export const Placeholder = styled.div`
  width: 100%;
  flex-basis: 24%;
  overflow: hidden;
  display: inline-block;
`;

export const MainMenuWrapper = styled(FlexContainer).attrs(({}) => ({}))`
  & {
    display: flex;
    flex-direction: column;
    position: absolute;
    flex-basis: 20%;
    overflow-y: scroll;

    width: auto;
    background-color: ${({ theme }) => theme.colors.lightgrey};
    transition: all 0.5s ease;
    ${media.greaterThan(breakpoints.ipad)`
		height: 100vh;
		padding: 30px 0px;

			`}
    ${media.lessThan(breakpoints.ipad)`
			height: ${({ open }) => (open ? "100vh" : "0vh")};
			
			visibility: ${({ open }) => (open ? "visible" : "hidden")};
			/* opacity: ${({ open }) => (open ? "1" : "0")}; */
			z-index: ${({ open }) => (open ? 100 : 0)};
			flex-basis: unset;
			overflow:auto;
			position: absolute;
			width: 100%;


			`}
  }
`;
export const IconWrapper = styled.span`
    i {
        color: ${({theme}) => theme.colors.primary};
        display: ${({show}) => (show ? "" : "none")};
        max-width: 22px;
        font-size: 21px;
        margin-right: 5px;
    }

    display: flex;
    justify-items: center;
    align-items: center;
    padding: 0 10px;
`;
export const ItemLinkWrapper = styled.div`
  height: 100%;
  width: 100%;

  &:hover {
    background-color: white;
  }
`;
export const MenuItemWrapper = styled.div`
  & {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: center;
    min-height: ${({ Depth }) => (Depth == 1 ? "64px" : "42px")};
    padding: 0.5rem 0;
    color: black;
    cursor: pointer;
    width: 100%;
    transition: 0.2s ease;
    margin-top: ${({ noMargin }) => noMargin && 0};
    border-color: ${({ IsActive, theme }) =>
      IsActive ? theme.colors.primary : "none"};
    border-bottom: 1px solid white;

    background-color: ${({ theme, Depth, IsActive }) =>
      IsActive
        ? theme.colors.bg1
        : Depth > 1
        ? theme.colors.white
        : theme.colors.lightgrey};
  }
`;
export const CollapsableMenuItem = styled.div`
  .fade-enter {
    max-height: 0;
    opacity: 0;
  }

  .fade-enter-active {
    max-height: 43px;
    opacity: 1;
    transition: all 300ms ease;
  }

  .fade-exit {
    max-height: 20px;
    opacity: 1;
    opacity: 0;
    transition: max-height 300ms ease;
  }

  .fade-exit-active {
    max-height: 0;
    opacity: 0;
    transition: max-height 300ms ease;
  }
  & {
    width: 100%;

    background-color: ${({ Depth, IsExpanded, HasChildren, theme }) =>
      Depth > 1 && IsExpanded && HasChildren
        ? theme.colors.bg2
        : Depth > 2
        ? theme.colors.bg2
        : ""};
  }
`;
